import { useEffect, ReactNode } from "react";
import { triggerHaptic } from "@/hooks/useHaptics";

interface HapticProviderProps {
  children: ReactNode;
}

// Selectors for tappable elements
const TAPPABLE_SELECTORS = [
  "button",
  "a",
  '[role="button"]',
  '[role="menuitem"]',
  '[role="menuitemcheckbox"]',
  '[role="menuitemradio"]',
  '[role="tab"]',
  '[role="link"]',
  '[role="option"]',
  '[role="switch"]',
  '[role="checkbox"]',
  '[role="radio"]',
  "[data-haptic]",
  ".cursor-pointer",
].join(", ");

export const HapticProvider = ({ children }: HapticProviderProps) => {
  useEffect(() => {
    const handlePointerDown = (e: PointerEvent) => {
      // Only trigger on touch interactions, not mouse
      if (e.pointerType !== "touch") return;
      
      // Check if target or ancestor is tappable
      const target = e.target as HTMLElement;
      const isTappable = target.closest(TAPPABLE_SELECTORS);
      
      // Also check for elements with onClick handlers (data attribute opt-in)
      const hasDataHaptic = target.closest("[data-haptic]");
      
      // Skip if explicitly opted out
      if (target.closest("[data-no-haptic]")) return;
      
      if (isTappable || hasDataHaptic) {
        triggerHaptic();
      }
    };

    document.addEventListener("pointerdown", handlePointerDown, { passive: true });
    
    return () => {
      document.removeEventListener("pointerdown", handlePointerDown);
    };
  }, []);

  return <>{children}</>;
};

export default HapticProvider;
